/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Activity_FertilizingInputs */

const vi_care_log_activity_fertilizing = /** @type {(inputs: Care_Log_Activity_FertilizingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bón phân`)
};

/**

* @param {Care_Log_Activity_FertilizingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_activity_fertilizing = /** @type {((inputs?: Care_Log_Activity_FertilizingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Activity_FertilizingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_activity_fertilizing(inputs)
});